import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosConfig';

// Асинхронное действие для получения доступов ко всем урокам
export const fetchLessonAccess = createAsyncThunk(
    'lessonAccess/fetchLessonAccess',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/lesson-access/all');
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Асинхронное действие для обновления доступа к уроку (только для админов)
export const updateLessonAccess = createAsyncThunk(
    'lessonAccess/updateLessonAccess',
    async ({ moduleId, lessonId, isLocked }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/lesson-access/update', {
                moduleId,
                lessonId,
                isLocked
            });
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    lessonAccess: [],
    loading: false,
    error: null
};

const lessonAccessSlice = createSlice({
    name: 'lessonAccess',
    initialState,
    reducers: {
        clearLessonAccessData: () => initialState
    },
    extraReducers: (builder) => {
        builder
            // Обработка fetchLessonAccess
            .addCase(fetchLessonAccess.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLessonAccess.fulfilled, (state, action) => {
                state.loading = false;
                state.lessonAccess = action.payload;
            })
            .addCase(fetchLessonAccess.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Не удалось получить данные о доступе к урокам';
            })

            // Обработка updateLessonAccess
            .addCase(updateLessonAccess.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateLessonAccess.fulfilled, (state, action) => {
                state.loading = false;
                // Обновляем в массиве только тот урок, который был изменен
                const updatedLesson = action.payload;
                const index = state.lessonAccess.findIndex(
                    lesson => lesson.moduleId === updatedLesson.moduleId &&
                        lesson.lessonId === updatedLesson.lessonId
                );

                if (index !== -1) {
                    state.lessonAccess[index].isLocked = updatedLesson.isLocked;
                }
            })
            .addCase(updateLessonAccess.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Не удалось обновить доступ к уроку';
            });
    }
});

export const { clearLessonAccessData } = lessonAccessSlice.actions;
export default lessonAccessSlice.reducer; 